import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'heading-xs-intr flex w-min cursor-default items-center px-2 text-[12px] tracking-[0.08em] whitespace-nowrap text-white uppercase'
  },
  variants: {
    link: {
      true: 'cursor-pointer'
    },
    color: {
      white: 'bg-brand-300',
      gr: 'bg-label-brand',
      black: 'bg-bg-items-black',
      done: 'bg-label-green',
      error: 'bg-label-red',
      canceled: 'bg-label-cancelled',
      unimportant: 'bg-label-unimportant',
      brand: 'bg-brand-400',
      custom:
        'bg-[var(--color-label-base-bg)] text-[var(--color-label-base-text)]'
    },
    variant: {
      default: 'h-6 items-center',
      brand: 'h-6 cursor-default items-center leading-none uppercase',
      // Передайте text-* для изменения цвета
      outline: 'border-1 border-[currentColor] !bg-transparent'
    },
    size: {
      s: 'h-4 rounded-[100px] px-2 text-[12px] leading-none font-light',
      m: 'h-6 px-2 text-[12px] leading-none',
      l: 'h-8 px-4 text-[16px] leading-none'
    },
    type: {
      search: {
        base: 'h-auto p-0.5 text-[9px] md:p-1 md:text-[10px]'
      },
      base: {}
    }
  },
  defaultVariants: {
    color: 'white',
    variant: 'default',
    size: 'm'
  }
});
